import React from "react";
import { useLocation, useNavigate, useParams, Params, NavigateFunction } from "react-router-dom";

export type RouteComponentProps = {
    router: {
        location: Location
        navigate: NavigateFunction
        params: Readonly<Params<string>>
    }
}

// wrapper suggested by react-router docs to replace the original function from earlier releases for class components
export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      return (
        <Component
          {...props}
          router={{ location, navigate, params }}
        />
      );
    }
    return ComponentWithRouterProp;
  }
